import { SiteType, siteType } from "@ots-frontend/ots-data";
import {
  siteCentralColor,
  siteDefaultColor,
  siteDisposalColor,
  sitePadColor,
  sitePondColor,
  siteStagingColor,
  siteYardColor
} from "../theme/colors";
import * as CSS from "csstype";

export const getSiteColorByType = (type: SiteType): CSS.Property.Color => {
  switch (type) {
    case siteType.central:
      return siteCentralColor;
    case siteType.pad:
      return sitePadColor;
    case siteType.pond:
      return sitePondColor;
    case siteType.disposal:
    case siteType.recyclingFacility:
      return siteDisposalColor;
    case siteType.yard:
      return siteYardColor;
    case siteType.staging:
      return siteStagingColor;
    default:
      return siteDefaultColor;
  }
};

export const getSiteColorRefByType = (type: SiteType): string => {
  switch (type) {
    case siteType.central:
      return "site-central";
    case siteType.pad:
      return "site-pad";
    case siteType.pond:
      return "site-pond";
    case siteType.disposal:
    case siteType.recyclingFacility:
      return "site-disposal";
    case siteType.yard:
      return "site-yard";
    case siteType.staging:
      return "site-staging";
    default:
      return "site-default";
  }
};
